import React from 'react';
import { Platform } from 'react-native';

import { options } from './options.Enum';

export const isAutoMode =
  (Platform.OS === 'ios' && Math.trunc(parseInt(Platform.Version, 10)) >= 13) ||
  (Platform.OS === 'android' && Platform.Version >= 29);

export const DisplayContext = React.createContext({
  option: isAutoMode ? options.auto : options.light,
  changeTheme: () => {},
});
